import { render, staticRenderFns } from "./InsightCaseSideBar.vue?vue&type=template&id=2fefaf04&scoped=true&"
import script from "./InsightCaseSideBar.vue?vue&type=script&lang=ts&"
export * from "./InsightCaseSideBar.vue?vue&type=script&lang=ts&"
import style0 from "./InsightCaseSideBar.vue?vue&type=style&index=0&id=2fefaf04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fefaf04",
  null
  
)

export default component.exports